<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title">Contents</h1>
<h2 class="toc"><a href="#/xhtml/04_Chapter1">Introduction</a></h2>
<h2 class="tocch"><a href="#/xhtml/05_Chapter2">THE BATTLES OF EL ALAMEIN</a></h2>
<h3 class="tocch1"><a href="#/xhtml/05_Chapter2#h3_1">Setting the Scene: Key Commanders of El Alamein; the Principal Cast</a></h3>
<h3 class="tocch1"><a href="#/xhtml/05_Chapter2#h3_2">The Supporting Cast – Order of Battle (ORBAT) as of 23 October 1942</a></h3>
<h3 class="tocch1"><a href="#/xhtml/05_Chapter2#h3_3">Prelude: The Battles of Gazala and Mersa Matruh</a></h3>
<h3 class="tocch1"><a href="#/xhtml/05_Chapter2#h3_4">Act One: The First Battle of El Alamein: A Line in the Sand</a></h3>
<h3 class="tocch1"><a href="#/xhtml/05_Chapter2#h3_5">Interlude – Taking Stock and the Battle of Alam Halfa</a></h3>
<h3 class="tocch1"><a href="#/xhtml/05_Chapter2#h3_6">Act Two, Scene One: The Second Battle of El Alamein: Operation Lightfoot</a></h3>
<h3 class="tocch1"><a href="#/xhtml/05_Chapter2#h3_7">Act Two, Scene Two: Dogfight: The Inferno Continues</a></h3>
<h3 class="tocch1"><a href="#/xhtml/05_Chapter2#h3_8">Act Two, Scene Three: Supercharge: Let Slip the Dogs of War</a></h3>
<h3 class="tocch1"><a href="#/xhtml/05_Chapter2#h3_9">Endings</a></h3>
<h2 class="tocch"><span href="#/xhtml/06_Chapter3" title="Link target outside of Sample">QUARTERMASTER’S SECTION</span></h2>
<h3 class="tocch1"><span href="#/xhtml/06_Chapter3#intro" title="Link target outside of Sample">Introduction</span></h3>
<h3 class="tocch1"><span href="#/xhtml/06_Chapter3#h3_1" title="Link target outside of Sample">Crusader Tank</span></h3>
<h3 class="tocch1"><span href="#/xhtml/06_Chapter3#h3_2" title="Link target outside of Sample">Panzer III ausf L</span></h3>
<h3 class="tocch1"><span href="#/xhtml/06_Chapter3#h3_3" title="Link target outside of Sample">Messerschmitt Bf 109 E-4/N Trop</span></h3>
<h3 class="tocch1"><span href="#/xhtml/06_Chapter3#h3_4" title="Link target outside of Sample">Curtiss P-40</span></h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?6cc08db0